// react
import React, { useEffect, useState, useContext } from "react";
import Compressor from 'compressorjs';

// third-party
import PropTypes, { element } from "prop-types";
import IconProgressBar from "../progressbar/IconProgressBarReclamo";
import TextProgressBar from "../progressbar/TextPogressBarReclamo";
import LineProgressBar from "../progressbar/LineProgressBar";
import Pages from "./pages";
import ControlButton from "../controlsNR/ControlButtonNR";
import Modal from "react-modal";
import { ImgEmailOK, ImgEmailFail } from "../../svg/reclamo";
import { ImgNext } from "../../svg/reclamo";
import {
  DataContextReclamo,
  DataProvier,
} from "../../context/DataContextReclamo";
import {
  contentTitlesClaim
} from "../../utils/constanst";
import {
  cedulaMask,
  cedulaPattern,
  customStyles,
  user,
  endPoints,
} from "../../utils/constanst";
import Container from "../Container";
import { initPage } from "../../data/data";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import httpSLNI, { getConfig } from "../../services/http";
import useToken from "../../hooks/useToken";
import useTokenServicioSLNI from "../../hooks/useTokenServiciosSLNI";
import Resizer from "react-image-file-resizer";
import { getToken } from "../../services/user";

const Root = () => {
   const { loading } = useToken();
  
  useEffect(() => {
    setTimeout(() => {
      const preloader = document.querySelector(".site-preloader");

     if (preloader) {
        preloader.addEventListener("transitionend", (event) => {
          
          if (event.propertyName === "opacity") {
            preloader.parentNode.removeChild(preloader);
          }
        });
        preloader.classList.add("site-preloader__fade");
      }
    }, 600);

  
  }, []);


 


  return (
    <DataProvier>
      <Container>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Switch>
            <Route exact path="/micrositio/notificatureclamo/" component={Layout} />
            <Redirect to="/micrositio/notificatureclamo/" />
          </Switch>
        </BrowserRouter>
      </Container>
    </DataProvier>
  );
};

const Layout = ({ location, history, ...rest }) => {
  const [index, setIndex] = useState(initPage);
  const { tramite, setTramite, changeHandler } = useContext(DataContextReclamo);
  const config =  getConfig();
  const totalPages = 4;
  let MensajeValidacion = "";

  var navigatorObject = window.navigator

  function GetTypeDevice(){
     let device = "Escritorio"
    if(navigator.userAgent.match(/iPad/i)){
      device = "iPad";
     }
     
     if(navigator.userAgent.match(/iPhone/i)){
      device = "iPhone";
     }
     if(navigator.userAgent.match(/Android/i)){
      device = "Android";
     }
     if(navigator.userAgent.match(/BlackBerry/i)){
      device = "BlackBerry";
     }
     if(navigator.userAgent.match(/webOS/i)){
      device = "webOS";
     }
     return device;
}

useEffect(() => { 
    window.addEventListener("beforeunload", alertUser);  
    return () => { window.removeEventListener("beforeunload", alertUser); };
  
  }); 

const alertUser = (e) => { 
  if(tramite.PuedeRecargarPagina == false)
  {
    e.preventDefault();  console.log(e); e.returnValue = "";
   
  }
};
 

  var cssButton = "";
  if(index == 0)
    cssButton = "control-button-btn-alone";
    
  const pages = contentTitlesClaim.length - 1;

  const prevState = rest?.location?.state;

  const fecha = new Date();


  const openModalMensajeValidacion = (txt) => setTramite({ ...tramite, ShowModalMensajeValidacion: true,MensajeValidacion :txt });
  const openModal = () => setTramite({ ...tramite, creado: true });
  const closeModal = () => setTramite({ ...tramite, creado: false });
  const openModalFaild = () => setTramite({ ...tramite, fallo: true });
  const closeModalFaild = () => setTramite({ ...tramite, fallo: false });
  const closeModalMensaje = () => setTramite({ ...tramite, ShowModalFallo: false });
  const closeModalMensajeValidacion = () => setTramite({ ...tramite, ShowModalMensajeValidacion: false });
  const goToFinish = () => {
    window.location.href = 'https://form.jotform.com/220183688758065'; 
  };


  const increment = (disabled) => {
    if (index <= totalPages) setIndex(index + 1);
    
    
    var txt ="";
    if(index ===1 && (!tramite.llamoServicioAsistencia)){
      txt = `Recuerde llamar siempre a nuestra asistencia al 1-800-4040 y poner en  aviso a la policía de tránsito.`;
      openModalMensajeValidacion(txt);
    }
    

   
  };

  const parseJwt = (token) => {
    try
    {
        return JSON.parse(atob(token.split('.')[1]));
    }catch( e) {
        return null;
    }
}

  const validateExpire = () => {
    let token = getToken();
        if(token != null)
        {
            const decodeJwt = parseJwt(token);
            console.log("🚀 ~ file: useTokenExpiration.js:22 ~ validate ~ decodeJwt:", decodeJwt)
            if (decodeJwt.exp * 1000 < Date.now()) {
                 console.log('expirado')
            }
            else{
              console.log('No Expirado')
            }
            
        }
  }

  /*useEffect(() => {
    validateExpire();
  })*/

  const decrement = () => {
    if (index !== 0) setIndex(index - 1);
    else back();
  };

  const handleSubmit = async (e) => {
    let result = document.querySelector("form").reportValidity();
    let duplicado =  false;
    if(index == 2 || index == 3)
      duplicado =  VerificarImgDuplicada();
    //increment(true);


    if(!duplicado){
      if (result) 
      increment(true);
    else{
      if(index ===0 && (tramite.correo === "")){
       var txt = `Estimado cliente, en caso de no poseer correo electrónico por favor escribirnos a nuestro Whatsapp +505 8794-4040 para notificar su reclamo.`;
        openModalMensajeValidacion(txt);
      }
     
    }
  }else{
    var txt = `Estimado Cliente, favor verifique no duplicar las fotografías que carga.`;
             openModalMensajeValidacion(txt);
  }

  };

  const back = () => {
    rest.history.push("/");
  };
  const textNext = index === totalPages ? "Notificar Siniestro" : "Siguiente";

  const getProcedure = () => {
    let result = document.querySelector("form").reportValidity();

    if (result) {
      setTramite({
        ...tramite,
        creado: true,
        guardandoRegistro: true
    });  
      GenerarNotificacionReclamo();
     // openModal();
    } else {
      //openModalFaild();
    }
  };

 
  const createNewFile = async (file, fileName) => {
    const extensionArray = file.name.split(".");
    const extension = extensionArray[extensionArray.length - 1];
    const newFile = await resizeFile2(file)
    const RenameFile = new File([newFile],`${fileName}.${extension}`, {lastModified:newFile.lastModified,type:newFile.type,name:fileName});
    return RenameFile;
  }

  const resizeFile2 =  async(file) => {
    return new Promise((resolve) => {
      new Compressor(file,{
        quality:0.6,
        type:"file",
        success(result){
          resolve( result);
        }
      });
    });
  }

  
  function downloadBlob(blob, name = 'file.txt') {
    // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
    const blobUrl = URL.createObjectURL(blob);
  
    // Create a link element
    const link = document.createElement("a");
  
    // Set link's href to point to the Blob URL
    link.href = blobUrl;
    link.download = name;
  
    // Append link to the body
    document.body.appendChild(link);
  
    // Dispatch click event on the link
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent('click', { 
        bubbles: true, 
        cancelable: true, 
        view: window 
      })
    );
  
    // Remove link from body
    document.body.removeChild(link);
  }
 
  const getStringDate =  ( date) => {
    return `${date.getFullYear()}-${("00" + (date.getMonth() + 1)).slice(-2)}-${("00" + date.getDate()).slice(-2)}`;
  }
  


  const GenerarNotificacionReclamo = async () => {
    const {
      nombre1,
      nombre2,
      apellido1,
      apellido2,
      fechaSiniestro,
      horaSiniestro,
      anio,
      mes,
      dia,
      hora,
      minutos,
      descripcionSiniestro,
      direccionSiniestro,
      idpoliza,
      correo,
      celular,
      figura,
      tiempo,
      poseeCorreduria,
      imgCarnetSeguroVehiculo,
      imgCertificadoTransito,
      imgCirculacionVehiculo,
      imgDañoVehiculo,
      imgIdentificacion,
      imgLicenciaConductor,
      nombreCorreduria,
      vehiculoPropio,
      nombrePropietarioVehiculo,
      sePresentoPoliciaTransito,
      llamoServicioAsistencia,
      huboPropiedadDañada,
      resultaronTercerosLesionados,
      imgPlacaVehiculo,
      imgEntornoSiniestro,
      imgParteDelanteraVehiculo,
      imgParteTraseraVehiculo,
      imgParteLateralDerechaVehiculo,
      imgParteLateralIzquierdaVehiculo,
      acceptaTerminos,
      tipoIdentificacion,
      numeroIdentificacion,
      ip
    } = tramite;

  
    const data = {
      Poliza: idpoliza,
      Fecha: getStringDate(fechaSiniestro),
      Hora: horaSiniestro.format('hh:mm A'),
      Lugar: direccionSiniestro,
      Descripcion: descripcionSiniestro,
      IdAplicacion: 1,
      IdUsuario: 0,
      Correo: correo,
      Celular: celular,
      Nombre1:nombre1 ,
      Nombre2:(nombre2.length == 0) ? '-' :nombre2 ,
      Apellido1:apellido1,
      Apellido2:(apellido2.length == 0) ? '-' :apellido2,
      Figura: (figura === true ? "PERJUDICADO":"ASEGURADO") ,
      PoseeCorreduria: poseeCorreduria  ,
      Correduria :  (nombreCorreduria.length == 0) ? '-' :nombreCorreduria ,
      VehiculoPropio: vehiculoPropio,
      NombrePropietarioVehiculo:  (nombrePropietarioVehiculo.length == 0) ? '-' :nombrePropietarioVehiculo ,
      SePresentoPoliciaTransito:sePresentoPoliciaTransito,
      LlamoServicioAsistencia:llamoServicioAsistencia,
      HuboPropiedadDanada:huboPropiedadDañada,
      ResultaronTercerosLesionados:resultaronTercerosLesionados,
      AceptaTerminos: true,
      TipoIdentificacion:tipoIdentificacion,
      Identificacion : numeroIdentificacion,
      CorreoSL:"-",
      NombreCorreoSL:"-",
      Navegador:navigatorObject.appVersion,
      Dispositivo:GetTypeDevice(),
      OS:"-",
      IP:ip,
      Lenguaje:navigatorObject.language,
      ZonaHoraria:Intl.DateTimeFormat().resolvedOptions().timeZone,
      Resolucion: `${window.screen.width}x${window.screen.height}`
    };
 

    const ArchivosAdjuntos2 = [];
    for (let i = 0; i < imgCarnetSeguroVehiculo.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgCarnetSeguroVehiculo[i],`CarnetSeguro_${i + 1}`));
    for (let i = 0; i < imgCertificadoTransito.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgCertificadoTransito[i],`CertificadoTránsito_${i + 1}`));
    for (let i = 0; i < imgCirculacionVehiculo.length; i++)
      ArchivosAdjuntos2.push(await createNewFile(imgCirculacionVehiculo[i],`Circulación_${i + 1}`));
    for (let i = 0; i < imgDañoVehiculo.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgDañoVehiculo[i],`DañoVehiculo_${i + 1}`));
    for (let i = 0; i < imgIdentificacion.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgIdentificacion[i],`Identificación_${i + 1}`));
    for (let i = 0; i < imgLicenciaConductor.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgLicenciaConductor[i],`Licencia_${i + 1}`));
    for (let i = 0; i < imgPlacaVehiculo.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgPlacaVehiculo[i],`Placa_${i + 1}`));
    for (let i = 0; i < imgEntornoSiniestro.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgEntornoSiniestro[i],`EntornoSiniestro_${i + 1}`));
    for (let i = 0; i < imgParteDelanteraVehiculo.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgParteDelanteraVehiculo[i],`ParteDelantera_${i + 1}`));
    for (let i = 0; i < imgParteTraseraVehiculo.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgParteTraseraVehiculo[i],`ParteTrasera_${i + 1}`));
    for (let i = 0; i < imgParteLateralDerechaVehiculo.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgParteLateralDerechaVehiculo[i],`LateralDerecha_${i + 1}`));
    for (let i = 0; i < imgParteLateralIzquierdaVehiculo.length; i++) 
      ArchivosAdjuntos2.push(await createNewFile(imgParteLateralIzquierdaVehiculo[i],`LateralIzquierda_${i + 1}`));  

  ExecuteDataAndFile(data,ArchivosAdjuntos2);
  

   /* setTramite((tramite) => ({
      ...tramite,
      creado: false,
      ShowModalFallo:true,
      MensajeError: '',
      guardandoRegistro:false
    }));*/
  };



  

   const VerificarImgDuplicada = () =>{
    const {
     
      imgCarnetSeguroVehiculo,
      imgCertificadoTransito,
      imgCirculacionVehiculo,
      imgDañoVehiculo,
      imgIdentificacion,
      imgLicenciaConductor,
      imgPlacaVehiculo,
      imgEntornoSiniestro,
      imgParteDelanteraVehiculo,
      imgParteTraseraVehiculo,
      imgParteLateralDerechaVehiculo,
      imgParteLateralIzquierdaVehiculo,
    } = tramite;
    var ArchivosAdjuntos = [];

    for (let i = 0; i < imgCarnetSeguroVehiculo.length; i++) {
      ArchivosAdjuntos.push(imgCarnetSeguroVehiculo[i]);
    }
    for (let i = 0; i < imgCertificadoTransito.length; i++) {
      ArchivosAdjuntos.push(imgCertificadoTransito[i]);
    }
    for (let i = 0; i < imgCirculacionVehiculo.length; i++) {
      ArchivosAdjuntos.push(imgCirculacionVehiculo[i]);
    }
    for (let i = 0; i < imgDañoVehiculo.length; i++) {
      ArchivosAdjuntos.push(imgDañoVehiculo[i]);
    }
    for (let i = 0; i < imgIdentificacion.length; i++) {
      ArchivosAdjuntos.push(imgIdentificacion[i]);
    }
    for (let i = 0; i < imgLicenciaConductor.length; i++) {
      ArchivosAdjuntos.push(imgLicenciaConductor[i]);
    }
    for (let i = 0; i < imgPlacaVehiculo.length; i++) {
      ArchivosAdjuntos.push(imgPlacaVehiculo[i]);
    }
    for (let i = 0; i < imgEntornoSiniestro.length; i++) {
      ArchivosAdjuntos.push(imgEntornoSiniestro[i]);
    }
    for (let i = 0; i < imgParteDelanteraVehiculo.length; i++) {
      ArchivosAdjuntos.push(imgParteDelanteraVehiculo[i]);
    }
    for (let i = 0; i < imgParteTraseraVehiculo.length; i++) {
      ArchivosAdjuntos.push(imgParteTraseraVehiculo[i]);
    }
    for (let i = 0; i < imgParteLateralDerechaVehiculo.length; i++) {
      ArchivosAdjuntos.push(imgParteLateralDerechaVehiculo[i]);
    }
    for (let i = 0; i < imgParteLateralIzquierdaVehiculo.length; i++) {
      ArchivosAdjuntos.push(imgParteLateralIzquierdaVehiculo[i]);
    }

    let duplicado = false;
    let cantidadDuplicado =0;
    ArchivosAdjuntos.forEach(element => {
      for (let i = 0; i < ArchivosAdjuntos.length; i++) {
        if (ArchivosAdjuntos[i].name === element.name) {
            cantidadDuplicado = cantidadDuplicado + 1;
        }
      }
      if(cantidadDuplicado > 1){
        duplicado = true;
      }
      cantidadDuplicado = 0;
    });


    return duplicado;

   }

   
   const ExecuteDataAndFile = (data,file) => {
 
 
 
   httpSLNI(endPoints.CrearReclamo)
   .multipleFileData(data,file)
   .then((resp) => {
    console.log("resp",resp)
    if(resp.valido === false){
      setTramite((tramite) => ({
        ...tramite,
        creado: false,
        ShowModalFallo:true,
        MensajeError: resp.mensaje,
        guardandoRegistro:false
      }));

    } else if(resp.valido === true)
    {
      setTramite((tramite) => ({
        ...tramite,
        creado: true,
        idtramite: resp.idTramite,
        guardandoRegistro:false,
        PuedeRecargarPagina:true
      }));
    }
   }) .catch((err) => {
    console.log("🚀 ~ file: root.js ~ line 485 ~ .then ~ err", err)
    setTramite((tramite) => ({
      ...tramite,
      creado: false,
      fallo:true,
      guardandoRegistro:false
    }));

});


   }



  return (
    <div className="layout sg-container_nr">
      <div>
        <h1 className="lfnr1 txt-center">¡Notificá tu reclamo ahora!</h1>

        <h1 className="lfnr2 txt-center">
          En tres simples pasos recibirás tu
          <br /> número de trámite
        </h1>
      </div>

<div className ="sg-container_nr2">
<IconProgressBar indexProgress={index} />
      <TextProgressBar indexProgress={index < 3 ? index : 2} />
  
      <LineProgressBar indexProgress={index < 3 ? index : 2} />
      <form action="">
        <Pages indexProgress={index} />
        <ControlButton cssButton={cssButton}>
          {index > 0 && (
            <button
              className={`control-button-btn-nr prev`}
              type="button"
              onClick={decrement}
            >
              Regresar
            </button>
          )}
          {index < totalPages  && (
            <button
              className="control-button-btn-nr next"
              type="button"
              onClick={handleSubmit}
            >
              {textNext}
              {index <= totalPages && <ImgNext />}
            </button>
          )}
          {index === totalPages   && (
            <button
              className="control-button-btn-nr next"
              type="button"
              onClick={getProcedure}
            >
              {textNext}
              {index <= totalPages && <ImgNext />}
            </button>
          )}
        </ControlButton>
      
      </form>
     
</div>
      

      <Modal
        isOpen={tramite.creado}
        onRequestClose={closeModal}
        className="modal-nr"
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
      >

{ tramite.guardandoRegistro === true && <div className="dialog-center-content">                   
                    <p className="text-center">Guardando tramite...</p>                  
                </div>
  }
  
  { tramite.guardandoRegistro === false && <div>
  <div className="dialog-center-content">
          <div className="">
            <h3 className="modal-lable-title">
              ¡La notificación de tu siniestro ha sido exitosa!
            </h3>
            <h3 className="modal-lable-title2">
              Trámite de Reclamo No. <br />
              <strong className="lfesm">{tramite.idtramite}</strong>
            </h3>
            <div className="dialog-center-content">
              <ImgEmailOK />
            </div>
            <p>
              Enviaremos a tu correo electrónico los documentos necesarios para
              completar tu expediente de reclamos.
            </p>
            <p>
              ¿Necesitas ayuda? Podés contactarnos a través de nuestro Whatsapp
              8794-4040 o bien llamar a nuestro Call Center al 2255-8484.
            </p>
          </div>
        </div>

        <div className="dialog-center-content">
          <button
            type="button"
            className="control-button-btn btn-color-primary modal-btn"
            onClick={() => goToFinish()}
          >
            Cerrar
          </button>
        </div>
        </div>}
      </Modal>
      <Modal
        isOpen={tramite.fallo}
   className ="modal-nr"
       
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
      >
        <h2 className="modal-lable-title">
          ¡Ocurrió un error al procesar tu notificación de reclamos!
        </h2>
        <h2 className="modal-lable-title2">
          <strong>Pero hemos recibido tus datos del siniestro </strong>
        </h2>
        <div className="dialog-center-content">
          <ImgEmailFail />
        </div>
        <h5 className="p_temrinosNR ">
          Un Oficial de Atención al Cliente se estará comunicando contigo para
          entregarte tú numero de trámite en un periodo no mayor a 24 horas
          hábiles. <br /> <br /> ¿Necesitas ayuda? Podés contactarnos a través
          de nuestro Whatsapp 8794-4040 o bien llamar a nuestro Call Center al
          2255-8484.
        </h5>
        <div className="dialog-center-content">
          <button
            type="button"
            className="control-button-btn btn-color-primary modal-btn"
            onClick={closeModalFaild}
          >
            Cerrar
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={tramite.ShowModalFallo}
   className ="modal-nr"
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
      >
        <h2 className="modal-lable-title">
          ¡Ocurrió un error al procesar tu notificación de reclamos!
        </h2>
        <h2 className="modal-lable-title2">
          <strong>Por favor validar el siguiente dato </strong>
        </h2>
        <div className="dialog-center-content">
          <ImgEmailFail />
        </div>
        <h5 className="p_temrinosNR ">
          {tramite.MensajeError}
        </h5>
        <div className="dialog-center-content">
          <button
            type="button"
            className="control-button-btn btn-color-primary modal-btn"
            onClick={closeModalMensaje}
          >
            Cerrar
          </button>
        </div>
      </Modal>


      <Modal
        isOpen={tramite.ShowModalMensajeValidacion}
     className ="modal-nr"
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
      >
        <h5 className="p_temrinosNR ">
          {tramite.MensajeValidacion}
        </h5>
        <div className="dialog-center-content">
          <button
            type="button"
            className="control-button-btn btn-color-primary modal-btn"
            onClick={closeModalMensajeValidacion}
          >
            Cerrar
          </button>
        </div>
      </Modal>
    </div>



  );
};

Root.propTypes = {
  /** current locale */
  locale: PropTypes.string,
  user: PropTypes.object,
};

export default Root;
